// Na mobilním zařízení nastaví výšky obrázků v galerii dle originálních rozměrů, které chodí z API.
import * as Sentry from '@sentry/browser';
import { galleryState as state } from './galleryState';

export const galleryResizeItems = (): void => {
  const itemsWrapper: HTMLElement | null = document.querySelector(
    '[data-slide-or-scroll-items-wrapper]'
  );
  if (!itemsWrapper) throw new Error('galleryResizeItemsOnMobile: itemsWrapper not found');

  const items: NodeListOf<HTMLLIElement> = itemsWrapper.querySelectorAll(
    '[data-gallery-item-position]'
  );
  const windowWidth = window.innerWidth;
  const sidePadding = 16;
  const galleryItemWidth = windowWidth - sidePadding * 2;

  // Pro každou položku:
  items.forEach((item) => {
    const {
      galleryItemWidth: width,
      galleryItemHeight: height,
      galleryItemType: itemType,
    } = item.dataset;

    if (itemType === 'lock') return;

    // Spočítat aspect ratio
    if (itemType === 'image' && (!height || !width)) {
      Sentry.captureMessage('GalleryResizeItems: Obrázek nemá v datech šířku nebo výšku', 'fatal');
      return;
    }

    // Reset
    item.style.marginLeft = '0px';
    item.style.marginRight = '0px';

    const aspectRatio = itemType === 'video' ? 0.5625 : Number(height) / Number(width);
    const elementNewHeight = aspectRatio * galleryItemWidth;

    // Nastavit výšku na příslušný element dle typu
    const itemWrapper: HTMLDivElement | null = item.querySelector(
      `.gallery-slide-or-scroll__item-${itemType}`
    );
    if (!itemWrapper) throw new Error('Gallery: itemWrapper not found');

    // Přidat výšku reklamy (může být součástí položky)
    const ad: HTMLElement | null = item.querySelector('.cnc_gallery_ad_position');
    if (ad) ad.style.minHeight = state.getIsMobile() ? '300px' : '0px';

    // Nastavit výšku na mobilním breakpointu
    if (itemType === 'video') {
      // Video
      if (itemWrapper && state.getIsMobile()) {
        itemWrapper.style.height = `${elementNewHeight}px`;
      } else {
        // Reset pro desktop
        itemWrapper?.style.removeProperty('height');
      }
    } else {
      // Obrázek
      const image = itemWrapper?.querySelector('img');
      if (image)
        if (state.getIsMobile()) {
          image.style.height = `${elementNewHeight}px`;
          image.style.width = `${galleryItemWidth}px`;
        } else {
          // Reset pro desktop
          image?.removeAttribute('style');
        }
    }
  });
};
